module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/clientes-pymes/clientes-pymes.component.css
// module id = ./src/app/components/clientes-pymes/clientes-pymes.component.css
// module chunks = main